// extracted by mini-css-extract-plugin
export var border = "_y-8";
export var brand = "_y-t";
export var button = "_y-l";
export var center = "_y-a";
export var centered = "_y-6";
export var closeButton = "_y-c";
export var disabledWrapper = "_y-m";
export var error = "_y-p";
export var extraLarge = "_y-4";
export var extraSmall = "_y-1";
export var fill = "_y-i";
export var footer = "_y-h";
export var footerAction = "_y-j";
export var footerButtons = "_y-k";
export var header = "_y-7";
export var headerWithClose = "_y-d";
export var icon = "_y-o";
export var info = "_y-s";
export var inline = "_y-9";
export var large = "_y-3";
export var main = "_y-e";
export var modal = "_y-0";
export var nearFull = "_y-5";
export var neutral = "_y-u";
export var noPadding = "_y-g";
export var none = "_y-v";
export var scrollable = "_y-f";
export var small = "_y-2";
export var success = "_y-r";
export var tight = "_y-n";
export var titleIcon = "_y-b";
export var warn = "_y-q";